var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ShowNoticeContent" }, [
    _vm.content.headline
      ? _c("p", { staticClass: "notice_headline" }, [
          _vm._v("\n    " + _vm._s(_vm.content.headline) + "\n  "),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.content.subtitle
      ? _c("p", { staticClass: "notice_subtitle" }, [
          _vm._v("\n    " + _vm._s(_vm.content.subtitle) + "\n  "),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "ul",
      { class: ["notice_paragraphs", "notice_deep_" + _vm.deepIndex] },
      _vm._l(_vm.content.paragraphs, function (paragraph, index) {
        return _c(
          "li",
          { key: index, staticClass: "notice_paragraph" },
          [
            typeof paragraph === "string"
              ? _c("span", [_vm._v(_vm._s(paragraph))])
              : _c("ShowNoticeContent", {
                  attrs: { content: paragraph, deepIndex: _vm.deepIndex + 1 },
                }),
          ],
          1
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }